import React, { Component } from "react"

import { Link } from "gatsby"

import Logo from "../images/logo_extreme_a.svg"
import Teaser from "../images/teaser.svg"


function toggleHamburger(event) {
  const primaryNav = document.getElementById("primary-nav")
  const hamburgerOpen = document.querySelector(".hamburger-open")
  const hamburgerClose = document.querySelector(".hamburger-close")
  const hitTheFloor = document.body
  hamburgerOpen?.classList.toggle("hidden")
  hamburgerClose?.classList.toggle("hidden")
  primaryNav?.classList.toggle("translate-x-full")
  hitTheFloor.classList.toggle("overflow-clip")
}

class Header extends Component<{ location: Location }, {}, {}> {

  componentDidMount() {
    const hamburgerBtn = document.querySelector(".hamburger")
    hamburgerBtn?.removeEventListener("click", toggleHamburger)
    hamburgerBtn?.addEventListener("click", toggleHamburger)
  }

  render() {
    const pathname = this.props.location ? this.props.location.pathname : ""

    // TODO: implement search box: https://developers.google.com/search/docs/advanced/structured-data/sitelinks-searchbox

    return (
      <header id="top" className="container">
        <div className="flex items-center justify-between pt-6 md:-mr-4">
          <div className="flex items-center gap-10 md:w-full md:justify-between">

            <a href="/" className="relative z-50 w-40 lg:w-auto">
              <img className="md:w-full" src={Logo} alt="logo" width="80" loading="lazy" />
            </a>

            <nav id="primary-nav"
                  className="fixed inset-0 z-40 text-2xl font-bold duration-200 ease-in-out translate-x-full bg-white pt-28 md:static md:transform-none md:pt-0 md:text-base">
              <div className="flex flex-col md:flex-row relative">
                {pathname.match("cheatsheets") ?
                  <div className="absolute -bottom-5 -left-30 hidden md:block">
                    <img src={Teaser}
                          width={120}
                          alt="check out ->"
                          className=""
                    />
                  </div>
                  : <></>
                }
                <Link to="/courses/"
                      className="py-5 px-11 text-gray-400 hover:bg-rose-500/5 hover:text-rose-500 md:py-1.5 md:px-3">Courses</Link>
                <Link to="/cheatsheets/"
                      className="py-5 px-11 text-gray-400 hover:bg-rose-500/5 hover:text-rose-500 md:py-1.5 md:px-3">Cheatsheets</Link>
                <Link to="https://insights.extremeautomation.io/"
                      className="py-5 px-11 text-gray-400 hover:bg-rose-500/5 hover:text-rose-500 md:py-1.5 md:px-3">Writing</Link>
                <Link to="/speaking/"
                      className="py-5 px-11 text-gray-400 hover:bg-rose-500/5 hover:text-rose-500 md:py-1.5 md:px-3">Speaking</Link>
                {/* <Link to="/consulting/"
                      className="py-5 px-11 text-gray-400 hover:bg-rose-500/5 hover:text-rose-500 md:py-1.5 md:px-3">Consulting</Link> */}
                <Link to="/learnication/"
                      className="py-5 px-11 text-gray-400 hover:bg-rose-500/5 hover:text-rose-500 md:py-1.5 md:px-3">Learnication</Link>
                <Link to="/contact"
                      className="py-5 px-11 text-gray-400 hover:bg-rose-500/5 hover:text-rose-500 md:py-1.5 md:px-3">Contact</Link>
              </div>
            </nav>

          </div>

          <button aria-label="toggle menu" aria-controls="primary-nav" className="hamburger z-100 md:hidden">
            <svg className="w-4 h-4 hamburger-open" width="16" height="14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
              <path fill="#212121" d="M0 0h16v2H0zM0 6h16v2H0zM0 12h16v2H0z" />
            </svg>
            <svg className="hidden w-4 h-4 hamburger-close" width="14" height="14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
              <path
                d="m7 5.586 4.95-4.95 1.414 1.414L8.414 7l4.95 4.95-1.414 1.414L7 8.414l-4.95 4.95L.636 11.95 5.586 7 .636 2.05 2.05.636 7 5.586Z"
                fill="#212121" fillOpacity=".35" />
            </svg>
          </button>

        </div>
      </header>
    )
  }

}

export default Header
